export default __webpack_public_path__ + "static/media/logo_cejam.a39457a9.svg";